import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const purchases = [{
  name: 'Giulia M.',
  city: 'Milano'
}, {
  name: 'Francesca R.',
  city: 'Roma'
}, {
  name: 'Silvia B.',
  city: 'Torino'
}, {
  name: 'Martina D.',
  city: 'Napoli'
}, {
  name: 'Chiara F.',
  city: 'Bologna'
}, {
  name: 'Federica L.',
  city: 'Padova'
}, {
  name: 'Alessia C.',
  city: 'Firenze'
}, {
  name: 'Valentina S.',
  city: 'Verona'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(purchases[0]);
  useEffect(() => {
    const show = () => {
      setCurrent(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 6000);
    };
    const firstPopup = window.setTimeout(show, 3500);
    const interval = window.setInterval(show, 16000);
    return () => {
      window.clearTimeout(firstPopup);
      window.clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div role="status" aria-live="polite" className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 z-50 animate-slide-in flex justify-center sm:justify-end pointer-events-none" data-id="element-153" data-mp="27gayfrefnfqf">
      <div className="bg-brand-plum border-2 border-brand-gold shadow-[0_0_18px_rgba(232,93,151,0.55)] rounded-lg px-2.5 py-2 pr-7 max-w-[290px] w-full relative pointer-events-auto" data-id="element-154" data-mp="1xp6k8twkzywn">
        <button onClick={() => setVisible(false)} aria-label="Chiudi notifica" className="absolute top-1 right-1 text-white/60 hover:text-white" data-id="element-155" data-mp="2qd2c9lb7h2n3">
          <XIcon className="w-3.5 h-3.5" data-id="element-156" data-mp="2ge3c6r4iafbp" />
        </button>
        <div className="flex items-center gap-2" data-id="element-157" data-mp="2ce2y57lbk656">
          <div className="w-8 h-8 rounded-full bg-brand-pink flex items-center justify-center shrink-0 border border-white/60" data-id="element-158" data-mp="2cd9nhvj8owhr">
            <ShoppingBagIcon className="w-4 h-4 text-white" data-id="element-159" data-mp="14xwkeeqixtrd" />
          </div>
          <div className="leading-tight" data-id="element-160" data-mp="10xcmh8y4mm46">
            <p className="font-bold text-white text-[11px]" data-id="element-161" data-mp="12g2wgeo3y3l8">
              {current.name} da {current.city}, Italia
            </p>
            <p className="text-[10px] text-brand-blush font-semibold" data-id="element-162" data-mp="17duvdsn66pyx">ha appena acquistato questo libro digitale</p>
          </div>
        </div>
      </div>
    </div>;
}